{
	"termsAndConditions": {
		"title": "Allgemeine Geschäftsbedingungen",
		"submitTitle": "Akzeptieren & Weiter zur Datenschutzerklärung"
	},
	"privacyPolicy": {
		"title": "Datenschutzerklärung",
		"submitTitle": "Akzeptieren & Schließen",
		"backTitle": "Zurück"
	}
}
